module.exports = __webpack_public_path__ + "static/media/product integrated.98b3840d.jpg";